import script from "./PersonalOrderProjectDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./PersonalOrderProjectDetail.vue?vue&type=script&setup=true&lang=ts"

import "./PersonalOrderProjectDetail.vue?vue&type=style&index=0&id=26471d88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26471d88"]])

export default __exports__